require("slick-carousel");

const initStorySlider = () => {
  const $list = $(".js-about-story-list");

  if (!$list.length) return;

  $list.slick({
    infinite: true,
    speed: 350,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    prevArrow: $(".js-about-story-prev-btn"),
    nextArrow: $(".js-about-story-next-btn"),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
};

const initVideoModals = () => {
  $(document).on("show.bs.modal", ".modal[id^='modal__']", function () {
    const $iframe = $(this).find("iframe");
    const src = $iframe.data("src");
    if (src && !$iframe.attr("src")) {
      $iframe.attr("src", src);
    }
  });

  $(document).on("hide.bs.modal", ".modal[id^='modal__']", function () {
    $(this).find("iframe").attr("src", "");
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initStorySlider();
  initVideoModals();
});
